import { render } from "./SelectedBadge.vue?vue&type=template&id=21d50be6&scoped=true"
import script from "./SelectedBadge.vue?vue&type=script&lang=js"
export * from "./SelectedBadge.vue?vue&type=script&lang=js"

import "./SelectedBadge.vue?vue&type=style&index=0&id=21d50be6&scoped=true&lang=css"

import exportComponent from "../../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d50be6"]])

export default __exports__